module.exports = __webpack_public_path__ + "assets/media/tongue_training_light.1443a9d6.mp4";